import { render, staticRenderFns } from "./strings-table.vue?vue&type=template&id=55fd0b7e&"
import script from "./strings-table.vue?vue&type=script&lang=js&"
export * from "./strings-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports